export const listOfOptions = [
  {
    value: "Select Reason",
    text: "Select Reason",
  },
  {
    value: "Expired Receipt",
    text: "Expired Receipt",
  },
  {
    value: "Not Readable",
    text: "Not Readable",
  },
  {
    value: "Not a Valid Merchant",
    text: "Not a Valid Merchant",
  },
  {
    value: "Under $20",
    text: "Under $20",
  },
  {
    value: "Duplicated Receipts",
    text: "Duplicated Receipts",
  },
  {
    value: "Invalid Receipts",
    text: "Invalid Receipts",
  },
  {
    value: "Others",
    text: "Others",
  },
  {
    value: "Fraud/Misuse",
    text: "Fraud/Misuse",
  },
];

export const jsonConstant = {
  "user_roles": [
    {
      "label": "",
      "value": ""
    }
  ],
  "merchant_types": [

  ],
  "directory_category": [
    {
      "label": "",
      "value": "",
      "sub_category": [
        {
          "label": "",
          "value": ""
        }
      ]
    }
  ]
}


export const UpdateReceiptRejectionList: any[] = [
  {
    id: "1",
    label: "Expired Receipt",
    type: "Expired Receipt",
  },
  {
    id: "2",
    label: "Not Readable",
    type: "Not Readable",
    subCategory: [
      {
        id: "1",
        label: "Date and/or Time is missing",
        type: "Date and/or Time is missing",
      },
      {
        id: "2",
        label: "Store name and/or Mall address is missing",
        type: "Store name and/or Mall address is missing",
      },
      {
        id: "3",
        label: "Final transaction amount missing",
        type: "Final transaction amount missing",
      },
      {
        id: "4",
        label: "Receipt does not contain most information",
        type: "Receipt does not contain most information",
      },
      {
        id: "5",
        label: "Receipt is blurred/illegible",
        type: "Receipt is blurred/illegible",
      },
    ]
  },
  {
    id: "3",
    label: "Not a Valid Merchant",
    type: "Not a Valid Merchant",
  },
  {
    id: "4",
    label: "Under $20",
    type: "Under $20",
  },
  {
    id: "5",
    label: "Duplicated Receipts",
    type: "Duplicated Receipts",
  },
  {
    id: "6",
    label: "Invalid Receipts",
    type: "Invalid Receipts",
    subCategory: [
      {
        id: "1",
        label: "Credit/Debit/Nets card charge slips not acceptable",
        type: "Credit/Debit/Nets card charge slips not acceptable",
      },
      {
        id: "2",
        label: "Top-ups/Topping up of Cash card/Prepaid Card/Store-valued Card are not acceptable",
        type: "Top-ups/Topping up of Cash card/Prepaid Card/Store-valued Card are not acceptable",
      },
      {
        id: "3",
        label: "Merchants’ loyalty programmes, bank rebates and payment card rebates not acceptable",
        type: "Merchants’ loyalty programmes, bank rebates and payment card rebates not acceptable",
      },
      {
        id: "4",
        label: "Purchase of Mall & Merchant Vouchers/Gift cards not acceptable",
        type: "Purchase of Mall & Merchant Vouchers/Gift cards not acceptable",
      },
      {
        id: "5",
        label: "Transactions made online are not acceptable",
        type: "Transactions made online are not acceptable",
      },
      {
        id: "6",
        label: "Ticket stubs, Lottery tickets, or other tickets of similar nature are not acceptable",
        type: "Ticket stubs, Lottery tickets, or other tickets of similar nature are not acceptable",
      },
      {
        id: "7",
        label: "Transactions made at Suntec Convention Centre are not acceptable",
        type: "Transactions made at Suntec Convention Centre are not acceptable",
      },
      {
        id: "8",
        label: "Receipts and transactions from Singpost and any other post offices are not acceptable",
        type: "Receipts and transactions from Singpost and any other post offices are not acceptable",
      },
      {
        id: "9",
        label: "Transactions made through the AXS or the SAM machines are not acceptable",
        type: "Transactions made through the AXS or the SAM machines are not acceptable",
      },
      {
        id: "10",
        label: "Order Form/Guest Check/Credit Note/Warranty Cards are are not acceptable",
        type: "Order Form/Guest Check/Credit Note/Warranty Cards are are not acceptable",
      },
      {
        id: "11",
        label: "Transaction was not made within the Suntec City outlet.",
        type: "Transaction was not made within the Suntec City outlet.",
      },
      {
        id: "12",
        label: "Transactions made at Atrium Fair, Push carts, pop-up stores within Suntec City are not acceptable",
        type: "Transactions made at Atrium Fair, Push carts, pop-up stores within Suntec City are not acceptable",
      },
      {
        id: "13",
        label: "Receipts & transactions from Banks, Money Changers & Financial Services are not acceptable",
        type: "Receipts & transactions from Banks, Money Changers & Financial Services are not acceptable",
      },
      {
        id: "14",
        label: "Transactions from purchase of Season parking are not acceptable",
        type: "Transactions from purchase of Season parking are not acceptable",
      },
      {
        id: "15",
        label: "Purchase of tobacco products are not eligible for points.",
        type: "Purchase of tobacco products are not eligible for points.",
      },
    ]
  },
  {
    id: "7",
    label: "Fraud/Misuse",
    type: "Fraud/Misuse",
    subCategory: [
      {
        id: "1",
        label: "Transaction not made by the same account holder",
        type: "Transaction not made by the same account holder",
      },
      {
        id: "2",
        label: "Suspected Staff Purchase",
        type: "Suspected Staff Purchase",
      },
      {
        id: "3",
        label: "Suspected Fraud/Misuse",
        type: "Suspected Fraud/Misuse",
      },
    ]
  },
  {
    id: "8",
    label: "Others",
    type: "Others",
    subCategory: [
      {
        id: "1",
        label: "Other vouchers are not accepted",
        type: "Other vouchers are not accepted",
      },
      {
        id: "2",
        label: "Amount is below $20 after excluding non-suntec city vouchers",
        type: "Amount is below $20 after excluding non-suntec city vouchers",
      },
      {
        id: "3",
        label: "Multiple Receipts in a single image",
        type: "Multiple Receipts in a single image",
      },
      {
        id: "4",
        label: "CRM Redemption",
        type: "CRM Redemption",
      },
    ]
  },
]